import {ON_HAND_QUERY_SUFFIXES, PCLOSE_QUERY_SUFFIXES} from './scenarioCacheUtils';

const MATCHING = ['renewalMatches', 'renewalGaps', 'renewalGapCandidates'];
export const numericRenewalRevision = revision => {
    const value = typeof revision === 'number' || (typeof revision === 'string' && /^\d+$/.test(revision))
        ? Number(revision) : NaN;
    return Number.isSafeInteger(value) && value >= 0 ? value : -1;
};
export const knownRenewalRevision = (queryClient, accountId) => Math.max(-1,
    ...queryClient.getQueryCache().getAll().filter(query => query.queryKey[0] === 'data-status' && query.queryKey[2] === accountId)
        .map(query => numericRenewalRevision(query.state.data?.dataStatus?.renewal_metadata?.matching_revision)));
export function renewalQueryKind(queryKey, accountId = null) {
    const root = queryKey?.[0];
    if (MATCHING.includes(root)) return !accountId || queryKey[1] === accountId ? 'matching' : null;
    if (queryKey?.[1] === 'board-stats-dollar-retention-drilldown' && (!accountId || root === accountId)) return 'related';
    if (typeof root !== 'string' || (accountId && !root.startsWith(`${accountId}_`))) return null;
    if (PCLOSE_QUERY_SUFFIXES.some(suffix => root.endsWith(`_${suffix}`))) return 'detail';
    if (ON_HAND_QUERY_SUFFIXES.some(suffix => root.endsWith(`_${suffix}`))
        || root.includes('arr-waterfall-projections')) return 'forecast';
    if (['revenue-forecast', 'revenue-projections'].some(suffix => root.includes(suffix))) return 'related';
    if (root.endsWith('_board-stats-dollar-retention-drilldown') || root.endsWith('_board-stats-dollar-retention')) return 'related';
    return null;
}

export function recordRenewalRevision(queryClient, accountId, revision) {
    revision = numericRenewalRevision(revision);
    if (revision < 0) return false;
    let updated = false;
    queryClient.setQueriesData({predicate: query => query.queryKey[0] === 'data-status' && query.queryKey[2] === accountId}, previous => {
        const metadata = previous?.dataStatus?.renewal_metadata;
        if (!metadata || metadata.customer_id !== accountId || revision <= numericRenewalRevision(metadata.matching_revision)) return previous;
        updated = metadata.forecast_enabled !== false;
        return {...previous, dataStatus: {...previous.dataStatus, renewal_metadata: {...metadata, matching_revision: revision}}};
    });
    return updated;
}

// Return only the table refresh promise; slow forecasts never hold the editor.
export function invalidateRenewalConsumers(queryClient, accountId, {refetchForecasts = true} = {}) {
    if (!accountId) return Promise.resolve();
    queryClient.invalidateQueries({predicate: query => renewalQueryKind(query.queryKey, accountId) === 'forecast',
        refetchType: refetchForecasts ? 'active' : 'none'}, {cancelRefetch: false}).catch(() => {});
    // Revenue queries do not carry renewal versions; preserve their existing
    // active refetch even when versioned ARR/Scenarios keys change themselves.
    queryClient.invalidateQueries({predicate: query => renewalQueryKind(query.queryKey, accountId) === 'related'},
        {cancelRefetch: false}).catch(() => {});
    queryClient.invalidateQueries({predicate: query => renewalQueryKind(query.queryKey, accountId) === 'detail'},
        {cancelRefetch: false}).catch(() => {});
    // A failed read must never reject a successfully committed mutation.
    return queryClient.invalidateQueries({predicate: query => renewalQueryKind(query.queryKey, accountId) === 'matching'},
        {cancelRefetch: false}).catch(() => {});
}
